<template>
    <div class="container">
      <section class="ba-grid ba-gp-08">
        <div class="ba-w-100 ba-flex ba-jc-fe ba-ai-center ba-gp-08">
          <button type="button" class="ba-btn ba-md ba-blue" @click.prevent="$refs['integration-config'].open()">
            <builderall-icon code='2780'></builderall-icon>
            {{ $t('ct-create-new-integration') }}
          </button>
          <!-- <router-link :to="{ name: 'EmailsIntegrations', params: { website_id: website.encrypted_id, data: website } }" -->
           <button @click="$emit('setComponent', 'EmailsIntegrations')"
            class="ba-btn ba-md ba-blue">
            <builderall-icon code='2780'></builderall-icon>
            {{ $t('ct-manager-emails-integrations') }}
        </button>
        </div>
  
        <div class="ba-w-100 ba-grid ba-gp-08">
          <div class="container-empty-integrations text-center" v-if="integrations_config.length === 0">
            <p>{{ $t('ct-integration-create-first-with') }}:</p>
            <div class="container-box-integrations">
              <div class="box-integrations" v-for="(elmt) in integration_types"
                @click.prevent="openCreateIntegrationConfig(elmt.id)"
                v-if="($i18n.locale.toLowerCase() !== 'pt_br' && !['monetizze', 'eduzz'].includes(elmt.key)) || ($i18n.locale.toLowerCase() === 'pt_br' && !['digistore24'].includes(elmt.key))">
                <img :src="`/static/images/payment-methods/logo-${elmt.key.toLowerCase().split('_').join('-')}.png`" />
              </div>
            </div>
          </div>
  
          <div class="container-boxs-integrations-offer" v-else>
            <div class="box box-integrations-offer box-20" v-for="(integration, index) in integrations_config">
              <div class="content-image">
                <img
                  :src="`/static/images/payment-methods/logo-${integration.type.key.toLowerCase().split('_').join('-')}.png`" />
              </div>
              <div class="content-config">
                <p class="config-name">{{ integration.name.length > 20 ? integration.name.substring(0, 20) + '...' :
                  integration.name }}</p>
                <div class="config-options">
                  <button @click.prevent="openEditIntegrationConfig(integration)"
                    class="ba-btn ba-btn-normal ba-sm ba-rounded">
                    <builderall-icon code='edit' />
                  </button>
                  <button class="ba-btn ba-btn-trash ba-sm ba-rounded"
                    @click.prevent="confirmDelete('integrationConfig', integration)">
                    <builderall-icon code='trash' />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <sweet-modal ref="integration-config" width="60vw" hide-close-button >
        <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
          <h5 class="ba-color-blue1">{{ $t('ct-create-group') }}</h5>
          <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="close">
            <builderall-icon code='64f7' />
          </button>
        </div>
        <hr class='ba-hr-row'>
        <div class="ba-grid ba-mg-y-1" style="height: 600px; overflow-x: hidden; overflow-y: scroll;">
          <form @submit.prevent="" id="integration-config">
            <div class="ba-f-row ba-pd-r-1 modal-element">
              <div class="box-type-integrations-container col-12" v-if="integrationConfig.action === 'create'">
                <div class="box-choises">
                  <div class="option-box image" :class="elmt.key.toLowerCase()" v-for="(elmt) in integration_types"
                    v-if="($i18n.locale.toLowerCase() !== 'pt_br' && !['monetizze', 'eduzz'].includes(elmt.key)) || ($i18n.locale.toLowerCase() === 'pt_br' && !['digistore24', 'copecart'].includes(elmt.key))">
                    <label :for="`payment-method-${elmt.key.toLowerCase()}`">
                      <input type="radio" name="payment_method" class="payment-method"
                        v-model="integrationConfig.integration_type_id" :id="`payment-method-${elmt.key.toLowerCase()}`"
                        :value="elmt.id" :class="{ 'is-invalid': errors.has('integrationConfig.payment_method') }"
                        @change="[changePaymentMethodType(), errors.clear('integrationConfig.payment_method')]"
                        required="required" />
                    </label>
                  </div>
                </div>
                <span v-if="errors.has('integrationConfig.payment_method')" class="invalid-feedback"
                  :class="{ 'd-block': errors.has('integrationConfig.payment_method') }"
                  v-text="errors.get('integrationConfig.payment_method')"></span>
              </div>
              <div v-else class="box-type-integrations-container" style="width: 150px;">
                <div class="box-choises">
                  <div class="option-box image" :class="integrationConfig.type.key.toLowerCase()">
                    <!-- <img :src="`/static/images/payment-methods/logo-${integrationConfig.type.key.toLowerCase().split('_').join('-')}.png`" /> -->
                  </div>
                </div>
              </div>
  
              <div class="ba-grid ba-gp-08 ba-w-100">
                <template v-if="integrationConfig.type.key === 'monetizze'">
                  <div class="ba-box-input ba-w-100">
                    <label for="unique-key" class="ba-custom-label">{{ $t('ct-unique-key') }}</label>
                    <input type="text" v-model="integrationConfig.monetizze.unique_key" class="ba-input ba-md" name="unique_key"
                      id="unique-key" required="required" @keydown="errors.clear('integrationConfig.unique_key')"
                      :class="{ 'ba-error': errors.has('integrationConfig.unique_key') }"
                      :placeholder="$t('ct-unique-key-help')" />
                    <span v-if="errors.has('integrationConfig.unique_key')" class="ba-validation-text"
                      v-text="errors.get('integrationConfig.unique_key')"></span>
                  </div>
                </template>
  
                <template v-if="integrationConfig.type.key === 'jvzoo'">
                  <div class="ba-w-100 ba-flex ba-gp-08">
                    <div class="ba-box-input ba-w-50">
                      <label for="secret-key" class="ba-custom-label">{{ $t('ct-jvzipn-secret-key') }}</label>
                      <input type="text" v-model="integrationConfig.jvzoo.secret_key" class="ba-input ba-md" name="secret-key"
                        id="secret-key" required="required" @keydown="errors.clear('integrationConfig.secret_key')"
                        :class="{ 'ba-error': errors.has('integrationConfig.secret_key') }"
                        :placeholder="$t('ct-token-help')" />
                      <span v-if="errors.has('integrationConfig.secret_key')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.secret_key')"></span>
                    </div>
  
                    <div class="ba-box-input ba-w-50">
                      <label for="product-id" class="ba-custom-label">{{ $t('ct-product-id') }}</label>
                      <input type="text" v-model="integrationConfig.jvzoo.product_id" class="ba-input ba-md" name="product-id"
                        id="product-id" required="required"
                        @keydown="[getURLCheckout(), errors.clear('integrationConfig.product_id')]"
                        @change="[getURLCheckout(), errors.clear('integrationConfig.product_id')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.product_id') }"
                        :placeholder="$t('ct-product-id-help')" />
                      <span v-if="errors.has('integrationConfig.product_id')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.product_id')"></span>
                    </div>
                  </div>
                </template>
  
                <template v-if="integrationConfig.type.key === 'hotmart'">
                  <div class="ba-grid">
                    <label for="version" class="ba-custom-label">{{ $t('ct-version-api') }}</label>
                    <select v-model="integrationConfig.hotmart.version" class="ba-select ba-md" name="version"
                      id="version" required="required" @change="errors.clear('integrationConfig.version')"
                      :class="{ 'is-invalid': errors.has('integrationConfig.version') }"
                      :placeholder="$t('ct-version-help')">
                      <option value="1.0.0">1.0.0</option>
                      <option value="2.0.0">2.0.0</option>
                    </select>
                  </div>
                  <div class="ba-w-100 ba-flex ba-gp-08">
                    <div class="ba-box-input ba-w-50">
                      <label for="token" class="ba-custom-label">{{ $t('ct-token') }}</label>
                      <input type="text" v-model="integrationConfig.hotmart.token" class="ba-input ba-md" name="token"
                        id="token" required="required" @keydown="errors.clear('integrationConfig.token')"
                        :class="{ 'ba-error': errors.has('integrationConfig.token') }"
                        :placeholder="$t('ct-token-help')" />
                      <span v-if="errors.has('integrationConfig.token')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.token')"></span>
                    </div>
                    <div class="ba-box-input ba-w-50">
                      <label for="hotmart-product-id" class="ba-custom-label">{{ $t('ct-product-id') }}</label>
                      <input v-if="integrationConfig.hotmart.version === '2.0.0'" type="text"
                        v-model="integrationConfig.hotmart.product_id" class="ba-input ba-md" name="hotmart-product-id"
                        id="hotmart-product-id" required="required"
                        @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.hotmart_product_id')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.hotmart_product_id') }"
                        :placeholder="$t('ct-product-id-help')" />
                      <input v-else type="text" v-model="integrationConfig.hotmart.product_id" class="ba-input ba-md"
                        name="hotmart-product-id" id="hotmart-product-id"
                        @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.hotmart_product_id')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.hotmart_product_id') }"
                        :placeholder="$t('ct-product-id-help')" />
                      <span v-if="errors.has('integrationConfig.hotmart_product_id')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.hotmart_product_id')"></span>
                      <small class="ba-color-black18 ba-montserrat-500 ba-text-12"
                        v-text="$t('ct-hotmart-product-id-help')"></small>
                    </div>
                  </div>
                </template>
  
                <template v-if="integrationConfig.type.key.toLowerCase() === 'digistore24'">
                  <div class="ba-box-input ba-w-100">
                    <label for="merchant-name" class="ba-custom-label">{{ $t('ct-merchant-name') }}</label>
                    <input type="text" v-model="integrationConfig.digistore24.merchant_name" class="ba-input ba-md"
                      name="merchant-name" id="merchant-name" required="required"
                      @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.merchant_name')]"
                      :class="{ 'is-invalidba-error': errors.has('integrationConfig.merchant_name') }"
                      :placeholder="$t('ct-merchant-name-help')" />
                    <span v-if="errors.has('integrationConfig.vendor_name')" class="ba-validation-text"
                      v-text="errors.get('integrationConfig.vendor_name')"></span>
                  </div>
                </template>
  
                <template v-if="integrationConfig.type.key.toLowerCase() === 'pabbly'">
                  <div class="ba-w-100 ba-flex ba-gp-08">
                    <div class="ba-box-input ba-w-50">
                      <label for="pabbly-username" class="ba-custom-label">{{ $t('ct-username') }}</label>
                      <input type="text" v-model="integrationConfig.pabbly.username" class="ba-input ba-md"
                        name="pabbly-username" id="pabbly-username" required="required"
                        @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.username')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.username') }"
                        :placeholder="$t('ct-username')" />
                      <span v-if="errors.has('integrationConfig.username')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.username')"></span>
                      <small class="ba-color-black18 ba-montserrat-500 ba-text-12"
                        v-text="$t('ct-pabbly-username-help')"></small>
                    </div>
                    <div class="ba-box-input ba-w-50">
                      <label for="pabbly-password" class="ba-custom-label">{{ $t('ct-password') }}</label>
                      <input type="text" v-model="integrationConfig.pabbly.password" class="ba-input ba-md"
                        name="pabbly-password" id="pabbly-password" required="required"
                        @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.password')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.password') }"
                        :placeholder="$t('ct-password')" />
                      <span v-if="errors.has('integrationConfig.password')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.password')"></span>
                    </div>
                  </div>
                </template>
  
                <template v-if="integrationConfig.type.key.toLowerCase() === 'copecart'">
                  <div class="ba-w-100 ba-flex ba-gp-08">
                    <div class="ba-box-input ba-w-50">
                      <label for="copecart-ipn-password" class="ba-custom-label">{{ $t('ct-ipn-password') }}</label>
                      <input type="text" v-model="integrationConfig.copecart.ipn_password" class="ba-input ba-md"
                        name="copecart-ipn-password" id="copecart-ipn-password" required="required"
                        @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.ipn_password')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.ipn_password') }"
                        :placeholder="$t('ct-ipn-password')" />
                      <span v-if="errors.has('integrationConfig.ipn_password')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.ipn_password')"></span>
                      <small class="ba-color-black18 ba-montserrat-500 ba-text-12"
                        v-text="$t('ct-ipn-password-help')"></small>
                    </div>
  
                    <div class="ba-box-input ba-w-50">
                      <label for="product-id" class="ba-custom-label">{{ $t('ct-product-id') }}</label>
                      <input type="text" v-model="integrationConfig.copecart.product_id" class="ba-input ba-md"
                        name="product-id" id="product-id" required="required"
                        @keydown="[getURLCheckout(), errors.clear('integrationConfig.product_id')]"
                        @change="[getURLCheckout(), errors.clear('integrationConfig.product_id')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.product_id') }"
                        :placeholder="$t('ct-product-id-help')" />
                      <span v-if="errors.has('integrationConfig.product_id')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.product_id')"></span>
                    </div>
                  </div>
                </template>
  
                <template v-if="integrationConfig.type.key.toLowerCase() === 'clickbank'">
                  <div class="ba-flex ba-ai-center ba-gp-08">
                    <div class="ba-box-input ba-w-100">
                      <label for="vendor-name" class="ba-custom-label">{{ $t('ct-vendor-name') }}</label>
                      <input type="text" v-model="integrationConfig.clickbank.vendor_name" class="ba-input ba-md"
                        name="vendor-name" id="vendor-name" required="required"
                        @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.vendor_name')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.vendor_name') }"
                        :placeholder="$t('ct-vendor-name-id-help')" />
                      <span v-if="errors.has('integrationConfig.vendor_name')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.vendor_name')"></span>
                    </div>
  
                    <div class="ba-box-input ba-w-100">
                      <label for="product-id" class="ba-custom-label">{{ $t('ct-product-id') }}</label>
                      <input type="text" v-model="integrationConfig.clickbank.product_id" class="ba-input ba-md"
                        name="product-id" id="product-id" required="required"
                        @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.product_id')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.product_id') }"
                        :placeholder="$t('ct-product-id-help')" />
                      <span v-if="errors.has('integrationConfig.product_id')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.product_id')"></span>
                    </div>
  
                    <div class="ba-box-input ba-w-100">
                      <label for="secret-key" class="ba-custom-label">{{ $t('ct-secret-key') }}</label>
                      <input type="text" v-model="integrationConfig.clickbank.secret_key" class="ba-input ba-md"
                        name="secret-key" id="secret-key" required="required"
                        @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.secret_key')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.secret_key') }"
                        :placeholder="$t('ct-secret-key-help')" />
                      <span v-if="errors.has('integrationConfig.secret_key')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.secret_key')"></span>
                    </div>
                  </div>
                </template>
  
                <template v-if="integrationConfig.type.key === 'digital_manager_guru'">
                  <div class="ba-w-100 ba-flex ba-gp-08">
                    <div class="ba-box-input ba-w-50">
                      <label for="guru-product-id" class="ba-custom-label">{{ $t('ct-guru-product-id') }}</label>
                      <input type="text" v-model="integrationConfig.digital_manager_guru.product_id" class="ba-input ba-md"
                        name="guru-product-id" id="guru-product-id" required="required"
                        @keydown="[changePaymentMethodType(), errors.clear('integrationConfig.product_id')]"
                        :class="{ 'ba-error': errors.has('integrationConfig.product_id') }"
                        :placeholder="$t('ct-product-id-help')" />
                      <span v-if="errors.has('integrationConfig.product_id')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.product_id')"></span>
                      <small class="ba-color-black18 ba-montserrat-500 ba-text-12"
                        v-text="$t('ct-guru-product-help')"></small>
                    </div>
                    <div class="ba-box-input ba-w-50">
                      <label for="guru-api-token" class="ba-custom-label">{{ $t('ct-api-token') }}</label>
                      <input type="text" v-model="integrationConfig.digital_manager_guru.api_token" class="ba-input ba-md"
                        name="guru-api-token" id="guru-api-token" required="required"
                        @keydown="errors.clear('integrationConfig.api_token')"
                        :class="{ 'ba-error': errors.has('integrationConfig.api_token') }"
                        :placeholder="$t('ct-api-token-help')" />
                      <span v-if="errors.has('integrationConfig.api_token')" class="ba-validation-text"
                        v-text="errors.get('integrationConfig.api_token')"></span>
                    </div>
                  </div>
                </template>
  
                <div class="ba-box-input ba-w-100">
                  <label for="name" class="ba-custom-label">{{ $t('ct-integration-name') }}</label>
                  <input type="text" v-model="integrationConfig.name" class="ba-input ba-md" name="name" required="required"
                    @keydown="errors.clear('integrationConfig.name')" :placeholder="$t('ct-integration-name-help')"
                    :class="{ 'ba-error': errors.has('integrationConfig.name') }" />
                  <span v-if="errors.has('integrationConfig.name')" class="ba-validation-text"
                    v-text="errors.get('integrationConfig.name')"></span>
                </div>
  
                <div class="ba-grid ba-w-100">
                  <label for="restrict_areas_ids" class="ba-custom-label">{{ $t('ct-restrict-areas') }}</label>
                  <v-select multiple :options="restrict_areas" label="name" v-model="integrationConfig.restrict_areas_ids"
                    :reduce="restrict_areas => restrict_areas.id"
                    :dir="this.$translate.getDir() ? this.$translate.getDir() : ''"
                    @input="errors.clear('integrationConfig.restrict_areas_ids')"
                    :class="{ 'is-invalid': errors.has('integrationConfig.restrict_areas_ids') }" required="required"
                    :placeholder="$t('ct-restrict-areas-help')">
                    <template slot="option" slot-scope="option">{{ option.name }}</template>
                  </v-select>
                  <small id="restrict_areas_ids" class="form-text text-muted">{{
                    $t('ct-integration-restrict-manual-only') }}</small>
                  <span v-if="errors.has('integrationConfig.restrict_areas_ids')" class="invalid-feedback"
                    :class="{ 'd-block': errors.has('integrationConfig.restrict_areas_ids') }"
                    v-text="errors.get('integrationConfig.restrict_areas_ids')"></span>
                </div>
  
                <div class="ba-grid ba-w-100">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="recurrence_enable" name="recurrence_enable"
                      v-model="integrationConfig.recurrence_enable">
                    <label class="form-check-label ba-text-14 ba-montserrat-500" for="recurrence_enable">{{
                      $t('ct-enable-recurrence') }}</label>
                  </div>
                </div>
  
                <div class="ba-grid ba-w-100" v-if="!integrationConfig.recurrence_enable">
                  <label for="expiration_time" class="ba-custom-label">{{ $t('ct-integration-expireted-time') }}</label>
                  <select id="expiration_time" name="expiration_time" class="ba-select ba-md"
                    v-model="integrationConfig.expiration_time"
                    @change="errors.clear('integrationConfig.expiration_time')"
                    :class="{ 'is-invalid': errors.has('integrationConfig.expiration_time') }" required="required">
                    <option value="20Y">{{ $t('ct-indefinite-period') }}</option>
                    <option value="7D">1 {{ $t('ct-week') }}</option>
                    <option value="15D">2 {{ $t('ct-weeks') }}</option>
                    <option value="1M">1 {{ $t('ct-month') }}</option>
                    <option value="2M">2 {{ $t('ct-months') }}</option>
                    <option value="3M">3 {{ $t('ct-months') }}</option>
                    <option value="4M">4 {{ $t('ct-months') }}</option>
                    <option value="5M">5 {{ $t('ct-months') }}</option>
                    <option value="6M">6 {{ $t('ct-months') }}</option>
                    <option value="7M">7 {{ $t('ct-months') }}</option>
                    <option value="8M">8 {{ $t('ct-months') }}</option>
                    <option value="9M">9 {{ $t('ct-months') }}</option>
                    <option value="10M">10 {{ $t('ct-months') }}</option>
                    <option value="11M">11 {{ $t('ct-months') }}</option>
                    <option value="1Y">1 {{ $t('ct-year') }}</option>
                    <option value="2Y">2 {{ $t('ct-years') }}</option>
                    <option value="3Y">3 {{ $t('ct-years') }}</option>
                  </select>
                  <span v-if="errors.has('integrationConfig.expiration_time')" class="invalid-feedback"
                    v-text="errors.get('integrationConfig.expiration_time')"></span>
                </div>
  
                <div class="ba-grid ba-w-100" v-if="integrationConfig.recurrence_enable">
                  <label for="recurrence-frequency" class="ba-custom-label">{{ $t('ct-recurring-payment-time') }}</label>
                  <input type="number" v-model="integrationConfig.recurrence_frequency" class="ba-input ba-md"
                    id="recurrence-frequency" name="recurrence_frequency" required="required" min="7" max="500"
                    :placeholder="$t('ct-recurring-payment-time-help')"
                    @keydown="[errors.clear('integrationConfig.recurrence_frequency')]"
                    @change="[errors.clear('integrationConfig.recurrence_frequency')]"
                    :class="{ 'ba-error': errors.has('integrationConfig.recurrence_frequency') }" />
                  <!-- <span class="d-inline-block m-1" style="width: 30%">{{ $t('ct-days') }}</span> -->
                  <span v-if="errors.has('integrationConfig.recurrence_frequency')" class="ba-validation-text"
                    v-text="errors.get('integrationConfig.recurrence_frequency')"></span>
                </div>
  
                <div class="ba-box-input ba-w-100"
                  v-if="!['clickbank', 'jvzoo', 'digital_manager_guru'].includes(integrationConfig.type.key.toLowerCase())">
                  <label for="url_checkout_external" class="ba-custom-label">{{ $t('ct-integration-url-checkout-external')
                    }}</label>
                  <input type="text" v-model="integrationConfig.config.url_checkout_external" class="ba-input ba-md"
                    id="url_checkout_external" name="url_checkout_external" required="required"
                    :placeholder="$t('ct-integration-url-checkout-external-help')"
                    @keydown="[getURLCheckout(), errors.clear('integrationConfig.url_checkout_external')]"
                    @change="[getURLCheckout(), errors.clear('integrationConfig.url_checkout_external')]"
                    :class="{ 'ba-error': errors.has('integrationConfig.url_checkout_external') }" />
                  <span v-if="errors.has('integrationConfig.url_checkout_external')" class="ba-validation-text"
                    v-text="errors.get('integrationConfig.url_checkout_external')"></span>
                </div>
  
                <div class="ba-grid ba-w-100"
                  v-if="!!integrationConfig.id && integrationConfig.integration_type_id !== 7">
                  <label for="url_checkout" class="ba-custom-label">{{ $t('ct-integration-url-checkout') }}</label>
                  <div class="input-group ba-w-100">
                    <div class="ba-flex ba-flex-nowrap ba-w-100">
                      <input type="text" :value="this.integrationConfig.url_checkout" disabled class="ba-input ba-w-100"
                        id="url_checkout" name="url_checkout" required="required"
                        :placeholder="$t('ct-integration-url-checkout-help')"
                        @keydown="errors.clear('integrationConfig.url_checkout')"
                        :class="{ 'ba-error': errors.has('integrationConfig.url_checkout') }" ref="checkout-link"
                        style="border-radius: 6px 0 0 6px;" />
                      <div class="input-group-append">
                        <span class="input-group-text" @click="copy($refs['checkout-link'], 'checkout-link')"
                          style="border-radius: 0px !important;">
                          <!-- <font-awesome-icon :icon="['fas', 'copy']" class="font-awesome-icon"
                            v-tooltip="{ content: $t('ct-copy-link'), class: 'tooltip-custom' }"
                            v-if="!copying.value || copying.element !== 'checkout-link'" /> -->
                          <builderall-icon code='b54c' v-if="!copying.value || copying.element !== 'checkout-link'"
                            ba-tooltip-position='top' :ba-tooltip-title="$t('ct-copy-link')"></builderall-icon>
                          <font-awesome-icon :icon="['fas', 'check']" class="font-awesome-icon"
                            v-tooltip="{ content: $t('ct-copied-link'), class: 'tooltip-custom' }"
                            v-else-if="copying.value && copying.element === 'checkout-link'" />
                        </span>
                        <a class="input-group-text" target="_blank" :href="integrationConfig.url_checkout"
                          v-tooltip="{ content: $t('ct-external-link'), class: 'tooltip-custom' }"
                          style="border-radius: 0 6px 6px 0;">
                          <builderall-icon code='6adb'></builderall-icon>
                          <!-- <font-awesome-icon :icon="['fas', 'external-link-square-alt']" class="font-awesome-icon" /> -->
                        </a>
                      </div>
                    </div>
                    <span v-if="errors.has('integrationConfig.url_checkout')" class="ba-validation-text"
                      v-text="errors.get('integrationConfig.url_checkout')"></span>
                  </div>
                </div>
  
                <!-- <div class="form-group col-12" v-if="integrationConfig.type.key"> -->
                <div class="ba-grid ba-w-100">
                  <label for="automatic_email" class="ba-custom-label">{{ $t('ct-integration-automatic-email') }}</label>
                  <select id="automatic_email" name="automatic_email" class="ba-select ba-md"
                    v-model="integrationConfig.automatic_email_id"
                    @change="errors.clear('integrationConfig.automatic_email_id')"
                    :class="{ 'ba-error': errors.has('integrationConfig.automatic_email_id') }">
                    <option value="" selected>{{ $t('ct-choose-automatic-email') }}</option>
                    <option v-for="(email, index) in automatic_emails" :value="email.id" :key="index">{{ email.name }}
                    </option>
                  </select>
                  <span v-if="errors.has('integrationConfig.automatic_email')" class="ba-validation-text"
                    v-text="errors.get('integrationConfig.automatic_email')"></span>
                </div>
  
                <div class="ba-grid ba-w-100">
                  <label for="url_checkout" class="ba-custom-label">{{ $t('ct-integration-webhook') }}</label>
                  <div class="input-group"
                    v-if="(!integrationConfig.id && ['monetizze'].includes(integrationConfig.type.key)) || integrationConfig.id">
                    <div class="ba-flex ba-flex-nowrap ba-w-100">
                      <input type="text" disabled class="ba-input ba-w-100" :value="getURLWebhook()" ref="webhook-link"
                        style="border-radius: 6px 0 0 6px;" />
                      <div class="input-group-append">
                        <span class="input-group-text" @click="copy($refs['webhook-link'], 'webhook-link')"
                          style="border-radius: 0 6px 6px 0;">
                          <builderall-icon code='b54c' v-if="!copying.value || copying.element !== 'webhook-link'"
                            ba-tooltip-position='top' :ba-tooltip-title="$t('ct-copy-link')"></builderall-icon>
                          <!-- <font-awesome-icon :icon="['fas', 'copy']" class="font-awesome-icon"
                            v-tooltip="{ content: $t('ct-copy-link'), class: 'tooltip-custom' }"
                            v-if="!copying.value || copying.element !== 'webhook-link'" /> -->
  
                          <font-awesome-icon :icon="['fas', 'check']" class="font-awesome-icon"
                            v-tooltip="{ content: $t('ct-copied-link'), class: 'tooltip-custom' }"
                            v-else-if="copying.value && copying.element === 'webhook-link'" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <p class="text-center ba-montserrat-700 ba-text-14" v-else>{{ $t('ct-integration-webhook-save') }}</p>
                </div>
  
              </div>
            </div>
          </form>
        </div>
        <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
          <button slot="button" class="ba-btn ba-md ba-light" @click.prevent="close">{{
            $t('ct-cancel') }}</button>
          <button v-if="!!!integrationConfig.id" type="button" slot="button" class="ba-btn ba-md  ba-blue"
            @click.prevent="saveAndGenerateURLCheckout">{{ $t('ct-url-checkout-and-save') }}
          </button>
          <button v-if="this.integrationConfig.action === 'edit'" slot="button" class="ba-btn ba-md ba-blue"
            @click.prevent="saveIntegration">{{ $t('ct-save')
            }}</button>
        </div>
  
      </sweet-modal>
  
      <modal-delete-component :show="modalDelete.integrationConfig.show" :values="modalDelete.integrationConfig.config"
        @cancel="cancelModal('integrationConfig')" @exclude="deleteIntegration"></modal-delete-component>
  
    </div>
  </template>
  
  <script>
  import NavComponent from '../../layout/nav/Nav.vue';
  import ModalDeleteComponent from './../../components/ModalDelete';
  import SiteSidebarComponent from './../../layout/site/SiteSidebar';
  import AlertBoxComponent from "../../../commons/AlertBoxComponent";
  import { SweetModal } from 'sweet-modal-vue';
  import Errors from '../../../../js/base/Errors';
  
  import { getAll as getAllRestrictArea } from './../../../../js/services/restrictArea/restrictArea';
  
  import {
    create as createIntegration,
    edit as editIntegration,
    exclude as excludeIntegration,
    getAll as getAllIntegrations
  } from './../../../../js/services/restrictArea/integration';
  
  import { getRestrictAreaIntegrationTypes } from './../../../../js/services/utils';
  import { getAll } from "../../../../js/services/restrictArea/automaticEmails";
  
  export default {
    name: 'IntegrationsComponent',
    components: {
      NavComponent,
      ModalDeleteComponent,
      SiteSidebarComponent,
      SweetModal,
      AlertBoxComponent
    },
  
    data() {
      return {
        copying: {
          value: false,
          element: ''
        },
        errors: new Errors(),
        website: { encrypted_id: '' },
        options_payment_methods: ['monetizze', 'jvzoo', 'hotmart', 'clickbank', 'copecart', 'pabbly'],
        recurrence_frequencies: [],
        restrict_areas: [],
        integration_types: [],
        payment_method_types: [],
        payment_method_configs: [],
        integrations_config: [],
        automatic_emails: [],
  
        integrationConfig: {
          type: {
            key: ''
          },
  
          hotmart: {
            token: '',
            offer_id: '',
            webhook: '',
            product_id: '',
            version: '1.0.0'
          },
  
          jvzoo: {
            secret_key: '',
            product_id: '' // clickbank product id
          },
  
          monetizze: {
            unique_key: ''
          },
  
          clickbank: {
            secret_key: '',
            vendor_name: '',
            product_id: '' // clickbank product id
          },
  
          eduzz: {
            api_key: 'fcd9520d91',
            public_key: '58722654'
          },
  
          digistore24: {
            merchant_name: ''
          },
  
          digital_manager_guru: {
            api_token: ''
          },
  
          pabbly: {
            product_id: '',
            username: '',
            password: '',
          },
  
          copecart: {
            product_id: '',
            ipn_password: '',
          },
  
          payment_method: '',
          action: 'create',
          payment_method_config_id: '',
          integration_type_id: '',
          automatic_email_id: '',
          name: '',
  
          url_checkout: '',
          url_checkout_external: '',
          has_webhook: false,
          has_url_checkout: false,
  
          config: {},
          enable_expiration: false,
          recurrence_enable: false,
          recurrence_frequency: false,
          expirated_at: '',
          expiration_time: '20Y',
          restrictAreas: [],
          restrict_areas_ids: [],
          restrictAreasObj: {}
        },
  
        modalDelete: {
          integrationConfig: {
            show: false,
            config: ''
          }
        }
      };
    },
  
    methods: {
  
      validate(type) {
        this.errors.clear();
  
        if (type === 'integrationConfig') {
          this.errors.validateFormat(document.getElementById('integration-config'), 'integrationConfig');
        }
  
        if (type === 'integrationConfig' && this.integrationConfig.restrict_areas_ids && this.integrationConfig.restrict_areas_ids.length === 0) {
          this.errors.add('restrict_areas_ids', 'validation-required', 'integrationConfig');
        }
  
        return this.errors.any();
      },
  
      saveIntegration() {
        if (!this.validate('integrationConfig')) {
          this.integrationConfig.website_id = this.website.encrypted_id;
  
          this.$loading.show();
  
          this.integrationConfig.config = this.integrationConfig[this.integrationConfig.type.key];
          this.integrationConfig.recurrence_frequency = +this.integrationConfig.recurrence_frequency;
  
          if (this.integrationConfig.action === 'create') {
            createIntegration(this.integrationConfig)
              .then(response => {
                if (response.data.success) {
                  this.updateListIntegration();
                  this.$snotify.success(this.$t('ct-saved-successfully'));
                  this.close();
                } else {
                  this.$snotify.error(this.$t('ct-error-saving'));
                  if (response.data.validator) {
                    this.errors.record({ integrationConfig: response.data.errors });
                  }
                }
              })
              .catch(() => {
                this.$snotify.error(this.$t('ct-error-saving'));
              })
              .finally(() => {
                this.$loading.hide();
              });
          } else {
            editIntegration(this.integrationConfig)
              .then(response => {
                if (response.data.success) {
                  this.updateListIntegration();
                  this.$snotify.success(this.$t('ct-saved-successfully'));
                  this.close();
                } else {
                  this.$snotify.error(this.$t('ct-error-saving'));
                  if (response.data.validator) {
                    this.errors.record({ integrationConfig: response.data.errors });
                  }
                }
              })
              .catch(() => {
                this.$snotify.error(this.$t('ct-error-saving'));
              })
              .finally(() => {
                this.$loading.hide();
              });
          }
        }
      },
  
      updateListIntegration() {
        this.$loading.show();
        getAllIntegrations(this.website.encrypted_id)
          .then(response => {
            this.integrations_config = response.data.data;
  
            this.integrations_config.map((method, index) => {
              method.config = (method.config) ? JSON.parse(method.config) : this.integrationConfig[method.type.key];
              this.$removeEmptyValuesObj(method);
              this.integrations_config[index] = { ...this.integrationConfig, ...method };
              this.integrations_config[index][method.type.key] = this.integrations_config[index].config;
            });
          })
          .finally(() => {
            this.$loading.hide();
          });
      },
  
      close() {
        this.$refs['integration-config'].close();
        setTimeout(() => {
          this.errors.clear();
          this.clear();
        }, 100);
      },
  
      clear() {
        this.integrationConfig = {
          type: {
            key: 'hotmart'
          },
  
          hotmart: {
            token: '',
            offer_id: '',
            product_id: '',
            version: '1.0.0'
          },
  
          jvzoo: {
            secret_key: '',
            product_id: '' // clickbank product id
          },
  
          monetizze: {
            unique_key: ''
          },
  
          clickbank: {
            secret_key: '',
            vendor_name: '',
            product_id: '' // clickbank product id
          },
  
          eduzz: {
            api_key: 'fcd9520d91',
            public_key: '58722654'
          },
  
          digistore24: {
            merchant_name: ''
          },
  
          digital_manager_guru: {
            api_token: ''
          },
  
          pabbly: {
            product_id: '',
            username: '',
            password: '',
          },
  
          copecart: {
            product_id: '',
            password: '',
          },
  
          payment_method: '',
          action: 'create',
          payment_method_config_id: '',
          integration_type_id: '',
          automatic_email_id: '',
          name: '',
          url_checkout: '',
          url_checkout_external: '',
  
          has_webhook: false,
          has_url_checkout: false,
  
          config: {},
          enable_expiration: false,
          recurrence_enable: false,
          recurrence_frequency: false,
          expirated_at: '',
          expiration_time: '20Y',
          restrictAreas: [],
          restrict_areas_ids: [],
          restrictAreasObj: {}
        };
      },
  
      openCreateIntegrationConfig(integration_type_id) {
        this.integrationConfig.integration_type_id = integration_type_id;
        this.changePaymentMethodType();
        this.$refs['integration-config'].open();
      },
  
      openEditIntegrationConfig(integration_config) {
        this.integrationConfig = integration_config;
        this.integrationConfig.action = 'edit';
  
        if (this.integrationConfig.type.key === 'hotmart' && typeof this.integrationConfig.hotmart.version === 'undefined') {
          this.integrationConfig.hotmart.version = '1.0.0';
        }
  
        this.integrationConfig.restrict_areas_ids = (integration_config.restrict_areas && integration_config.restrict_areas.length) ? integration_config.restrict_areas.map(e => e['id']) : [];
        this.changePaymentMethodType();
        this.$refs['integration-config'].open();
      },
  
      deleteIntegration(integration_config) {
        integration_config.website_id = this.website.encrypted_id;
  
        this.$loading.show();
  
        excludeIntegration(integration_config)
          .then(response => {
            this.integrations_config = this.integrations_config.filter(integration => integration.id !== integration_config.id);
            this.$snotify.success(this.$t('ct-successfully-deleted'));
          })
          .catch(() => {
            this.$snotify.error(this.$t('ct-error-deleting'));
          })
          .finally(() => {
            this.$loading.hide();
            this.cancelModal('integrationConfig');
          });
      },
  
      confirmDelete(type, config) {
        this.modalDelete[type].show = true;
        this.modalDelete[type].config = config;
      },
  
      cancelModal(type) {
        this.modalDelete[type].show = false;
        this.modalDelete[type].config = '';
      },
  
      changePaymentMethodType() {
        this.errors.clear();
  
        this.integrationConfig.type = this.integration_types.find(integration_type => integration_type.id === this.integrationConfig.integration_type_id);
        this.integrationConfig.config = this.integrationConfig[this.integrationConfig.type.key];
  
        this.getURLCheckout();
      },
  
      getURLCheckout() {
        var url_externa = this.integrationConfig.config.url_checkout_external;
  
        var type_params = {
          'hotmart': 'xcod=',
          'jvzoo': 'cvendthru=',
          'monetizze': 'src=',
          'clickbank': 'ctransaction=',
          'digistore24': 'custom=',
          'digital_manager_guru': '',
          'pabbly': '',
          'copecart': ''
        };
  
        var integration = this.integrationConfig;
  
        if (integration.type.key.toLowerCase() === 'clickbank' &&
          integration.clickbank.vendor_name && integration.clickbank.product_id
        ) {
          url_externa = `https://${integration.clickbank.vendor_name}.pay.clickbank.net?cbitems=${integration.clickbank.product_id}&csecretkey=${integration.clickbank.secret_key}`;
        } else if (integration.type.key.toLowerCase() === 'jvzoo' && integration.jvzoo.product_id) {
          url_externa = ` https://www.jvzoo.com/b/0/${integration.jvzoo.product_id}`;
        }
  
        var signal = url_externa && url_externa.indexOf('?') > -1 ? '&' : '?';
  
        if (!!url_externa && url_externa.length > 0 && integration.type.key.toLowerCase() !== 'pabbly') {
          let matchUrl = url_externa.match('^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]@!\\$&\'\\(\\)\\*\\+,;=.]+$');
          if (!matchUrl) {
            this.errors.add('url_checkout_external', 'validation-integration-external-url', 'integrationConfig');
          }
        }
        this.integrationConfig.url_checkout = (!url_externa) ? '' : url_externa + signal + type_params[integration.type.key.toLowerCase()] + integration.id;
      },
  
      encodeBase64(string) {
        return btoa(string);
      },
  
      getURLWebhook() {
        if (this.integrationConfig.type.key) {
          let url = `https://cheetah-api.builderall.com/members-area/notification/${this.integrationConfig.type.key.toLowerCase()}`;
  
          if (this.integrationConfig.type.key.toLowerCase() === 'clickbank') {
            url = url + `/${this.integrationConfig.clickbank.secret_key}`;
          }
  
          if (this.integrationConfig.type.key.toLowerCase() === 'digital_manager_guru') {
            url = url + `/${this.encodeBase64(this.integrationConfig.id)}`;
          }
  
          if (this.integrationConfig.type.key.toLowerCase() === 'hotmart') {
            url = url + `/${this.encodeBase64(this.integrationConfig.id)}`;
          }
  
          if (['pabbly', 'copecart', 'jvzoo'].includes(this.integrationConfig.type.key.toLowerCase())) {
            url = url + `/${this.encodeBase64(this.integrationConfig.id)}`;
          }
  
          return url;
        } else {
          return '';
        }
      },
  
      saveAndGenerateURLCheckout() {
        if (!this.validate('integrationConfig')) {
          this.integrationConfig.website_id = this.website.encrypted_id;
  
          this.$loading.show();
  
          this.integrationConfig.config = this.integrationConfig[this.integrationConfig.type.key];
  
          createIntegration(this.integrationConfig)
            .then(response => {
              if (response.data.success) {
                this.updateListIntegration();
                this.$snotify.success(this.$t('ct-saved-successfully'));
  
                let integration = response.data.data;
                this.$removeEmptyValuesObj(integration);
                integration.config = (integration.config) ? JSON.parse(integration.config) : this.integrationConfig[integration.type.key];
  
                integration = { ...this.integrationConfig, ...integration };
                integration[integration.type.key] = integration.config;
  
                this.integrationConfig = integration;
                this.integrationConfig.action = 'edit';
  
                this.integrationConfig.restrict_areas_ids = integration.restrict_areas.map(e => e['id']);
                this.changePaymentMethodType();
              } else {
                this.$snotify.error(this.$t('ct-error-saving'));
                if (response.data.validator) {
                  this.errors.record({ integrationConfig: response.data.errors });
                }
              }
            })
            .catch((error) => {
              console.error('error', error);
              this.$snotify.error(this.$t('ct-error-saving'));
            })
            .finally(() => {
              this.$loading.hide();
            });
        }
      },
  
      copy(input, element = false) {
        this.copying.element = element;
  
        try {
          let toCopy = input;
          toCopy.setAttribute('type', 'text');
          toCopy.removeAttribute('disabled');
          toCopy.select();
          this.copying.value = !!document.execCommand('copy');
          window.getSelection().removeAllRanges();
          toCopy.setAttribute('disabled', 'disabled');
  
          setTimeout(() => {
            this.copying.value = false;
            this.copying.element = '';
          }, 1000);
        } catch (err) {
          this.copying.value = false;
        }
      },
  
      goToWebPage(url) {
      }
  
    },
  
    async created() {
      this.website.encrypted_id = this.$route.params.website_id;
  
      getAllRestrictArea(this.website.encrypted_id)
        .then(response => {
          this.restrict_areas = response.data.data.filter(restrict => restrict.type_id === 3); // manual payment
        });
  
      getRestrictAreaIntegrationTypes()
        .then(response => {
          this.integration_types = response.data.data;
        });
  
      this.$loading.show();
  
      await getAll(this.website.encrypted_id, 'members_integrations_sale')
        .then(response => {
          if (response.data.success) {
            this.automatic_emails = response.data.data;
          }
        })
        .finally(() => this.$loading.hide());
  
      this.updateListIntegration();
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .box {
    justify-content: unset;
  }
  
  .image {
    &.monetizze {
      background-image: url("/static/images/payment-methods/logo-monetizze.png");
    }
  
    &.jvzoo {
      background-image: url("/static/images/payment-methods/logo-jvzoo.png");
    }
  
    &.hotmart {
      background-image: url("/static/images/payment-methods/logo-hotmart.png");
    }
  
    &.clickbank {
      background-image: url("/static/images/payment-methods/logo-clickbank.png");
    }
  
    &.digistore24 {
      background-image: url("/static/images/payment-methods/logo-digistore24.png");
    }
  
    &.digital_manager_guru {
      background-image: url("/static/images/payment-methods/logo-digital-manager-guru.png");
    }
  
    &.pabbly {
      background-image: url("/static/images/payment-methods/logo-pabbly.png");
    }
  
    &.copecart {
      background-image: url("/static/images/payment-methods/logo-copecart.png");
    }
  }
  
  section {
    font-family: Muli;
  }
  
  .modal-element {
    // color: #5a5959;
    color: #434343;
  
    h1 {
      font-weight: bold;
      font-size: 20px;
      color: #434343;
    }
  
    h2 {
      color: #5a5959;
      font-size: 18px;
    }
  
    .box-logo-edit {
      position: absolute;
      top: 30px;
      right: 46px;
  
      img {
        max-width: 140px;
        max-height: 40px;
      }
    }
  
    .form-card {
      background: #FFFFFF;
      border: 1px solid #E3E8EB;
      border-radius: 5px;
      padding: 15px;
      margin: 15px 0;
      max-height: 60vh;
      overflow: auto;
      width: 100%;
    }
  
    .box-logo-edit {
      float: right;
    }
  
    .box-type-integrations-container {
      margin: 20px 0;
      padding: 0;
    }
  
    .box-choises {
      display: flex;
      width: 100%;
  
      .option-box {
        padding: 10px;
        border: 1px solid rgba(211, 211, 211, 0.4);
        background-color: #FFFFFF;
        box-shadow: 0 1px 3px #00000029;
        border-radius: 16px;
        transition: all 0.2s ease-in-out;
        margin-left: 5px;
        margin-right: 5px;
        width: 110px;
        height: 70px;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: 80px auto;
        flex: 1;
        display: flex;
  
        &:first-child {
          margin-left: 0;
        }
  
        &:last-child {
          margin-right: 0;
        }
  
        &:hover {
          box-shadow: 0px 3px 3px #00000029;
        }
  
        label {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
  
        input {
          cursor: pointer;
          border: 2px solid transparent;
        }
      }
    }
  }
  
  .container-empty-integrations {
    p {
      font-size: 18px;
    }
  
    .container-box-integrations {
      height: 150px;
      align-items: center;
      justify-content: center;
      display: flex;
  
      .box-integrations {
        width: 130px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FFFFFF;
        border-radius: 16px;
        transition: all .5s ease;
        margin: 0 10px;
        border: 1px solid #E4EAF6;
  
        &:hover {
          box-shadow: 0px 15px 16px #00000029;
        }
  
        img {
          width: auto;
          max-width: 75%;
        }
  
      }
  
    }
  }
  
  .container {
    section {
      p {
        padding: 0;
        margin: 0;
      }
  
      .image {
        width: 100%;
        height: 70px;
        background-size: 70%;
        background-repeat: no-repeat;
        background-position: 50% 50%;
  
        &.monetizze {
          background-image: url("/static/images/payment-methods/logo-monetizze.png");
        }
  
        &.jvzoo {
          background-image: url("/static/images/payment-methods/logo-jvzoo.png");
        }
  
        &.hotmart {
          background-image: url("/static/images/payment-methods/logo-hotmart.png");
        }
  
        &.clickbank {
          background-image: url("/static/images/payment-methods/logo-clickbank.png");
        }
  
        &.digital_manager_guru {
          background-image: url("/static/images/payment-methods/logo-digital-manager-guru.png");
        }
      }
  
      .container-boxs-integrations-offer {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 0 -10px;
  
        .box-integrations-offer {
          flex-direction: column;
          // justify-content: space-between;
          // padding: 15px;
          border-radius: 16px;
          min-width: 250px;
          /*min-width: 18%;*/
          /*max-width: 18%;*/
          // height: 260px;
  
  
  
          .content-config {
            display: grid;
            gap: 10px;
            align-items: center;
            width: 100%;
            // margin: 10px 0 0 0;
            height: 57px;
            padding: 15px;
  
            .config-name {
              color: #1E1E2D;
              font-size: 16px;
              font-weight: 700;
              line-height: 25.6px;
              text-align: left;
            }
  
            .config-options {
              align-items: center;
              gap: 8px;
              height: 100%;
              display: flex;
              justify-content: flex-end;
  
              // .line {
              //   width: 2px;
              //   height: 30px;
              //   margin: 0 8px;
              //   border-right: 1px solid #CAE2FC;
              // }
            }
  
            span {
              width: 40px;
              height: 30px;
              display: inline-flex;
              align-items: center;
              text-align: center;
              font-size: 12px;
              padding: 0 5px;
              color: #5a5959;
              flex: 1;
  
              &:hover {
                background-color: #F5FAFF;
              }
            }
          }
  
          .content-image {
            width: 100%;
            height: 120px;
            // margin: 0 15px;
            background-color: #F5FAFF;
            // border: 1px solid #CAE2FC;
            border-radius: 16px 16px 0px 0px;
            text-align: center;
            align-items: center;
            display: inline-flex;
            justify-content: center;
  
            img {
              width: auto;
              max-width: 100%;
              height: auto;
              max-height: 50px;
            }
          }
        }
      }
    }
  }
  
  .input-group-append {
    .input-group-text {
      background-color: #eff2f8;
      border: none;
      font-size: 15px;
      color: #0080FC;
      padding: 3px 6px;
  
      &:last-child {
        padding-right: 15px;
      }
    }
  }
  
  .input-group {
    .ba-input {}
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/dashboard/pages/MembersArea/PaymentIntegrations.vue